export const environment = {
  production: false,
  name: 'stable',
  apiUrl: 'https://stable-core-api.smart.care/api',
  authUrl: 'https://stable-auth-api.smart.care',
  blobsApiUrl: 'https://stable-blobs-api.smart.care/api',
  coreCenterApiUrl: 'https://stable-ng-core-api.smart.care/center/api',
  oldAppUrl: 'https://stable-my.smartcare.com',
  flagsKey: '5e544c6aae2dad07c037b135',
};
